export const SENSOR_OBJECT_TYPE = 'sensor';
export const CAPTURE_OBJECT_TYPE = 'capture_record';

// 図面座標の15%以内のセンサーを自動紐付け対象とする
export const AUTO_LINK_DISTANCE_THRESHOLD = 0.15;
